import app from '@/app';

/* @ngInject */
function stateConfig($stateProvider, stateHelperProvider) {
	var states = [
		stateHelperProvider.search({
			name: 'budget-limit',
			component: 'budgetLimitsSearch',
			parent: 'entity',
			data: {
				viewAuthorities: ['ENTITIES_READ'],
				editAuthorities: ['ENTITIES_WRITE']
			}
		}),
		{
			name: 'budget-limit.detail',
			url: '/{id}',
			component: 'budgetLimitsDetail',
			resolve: {
        /* @ngInject */
        entity: (BudgetLimit, $transition$, entityInjector) =>
        entityInjector(BudgetLimit, $transition$.params().id, { items: [] }),
      }
		},
	];

	states.forEach(state => $stateProvider.state(state));
}

app.config(stateConfig);